query getInventorySkus {
  inventorySkus {
    ...fullInventorySkus
  }
} 